export const appendCsvQueryParam = (params, key, values) => {
  if (!Array.isArray(values) || values.length === 0) {
    return;
  }

  const normalized = values
    .map((value) => String(value || "").trim())
    .filter((value) => value.length > 0);

  if (normalized.length > 0) {
    params.set(key, normalized.join(","));
  }
};
